import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_ccy_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  display_long: fromDatatype.VarcharDatatypeInterface;
  display_main: fromDatatype.VarcharDatatypeInterface;
  display_medium: fromDatatype.VarcharDatatypeInterface;
  display_short: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}

export class bl_fi_mst_ccy_RowClass implements bl_fi_mst_ccy_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  display_long: fromDatatype.VarcharDatatypeInterface;
  display_main: fromDatatype.VarcharDatatypeInterface;
  display_medium: fromDatatype.VarcharDatatypeInterface;
  display_short: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}


